<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h3>Taisyklės</h3>
      </v-col>

      <v-col cols="12">
        <el-autocomplete
          :items="jarFormsForSelect"
          itemvalue="code"
          itemtext="text"
          label="Teisinė forma"
          multiple
          direct
          v-model="selectedForms"
        />

        <el-button
          class="mb-5"
          color="primary"
          icon="pridėti"
          title="Pridėti formas"
          :loading="loading"
          @click.native.stop="addJaForms()"
        />
      </v-col>

      <v-col cols="12">
        <v-card
          v-for="(formCode, index) in forms"
          :key="index"
          class="mb-2 bg-white border"
        >
          <v-card-text class="white d-flex justify-space-between">
            <div>
              {{ getFormTitle(formCode) }}
            </div>
            <div>
              <v-icon dense class="mx-1" @click="openAddFact(formCode)">mdi-plus</v-icon>
              <v-icon dense class="mx-1" @click="openDeleteForm(formCode)">mdi-delete-outline</v-icon>

              <v-icon v-if="!expandedForms.includes(formCode)" @click="showFacts(formCode)">mdi-chevron-right</v-icon>
              <v-icon v-else @click="hideFacts(formCode)">mdi-chevron-down</v-icon>
            </div>
          </v-card-text>
          <v-card-text class="px-0 py-0" v-if="expandedForms.includes(formCode)">
            <v-data-table
              class="mb-4 custom-table sticky-header"
              :loading="loading"
              :headers="headers"
              :items="getFormFacts(formCode)"
              :hide-default-footer="true"
              :items-per-page="-1"
            >
              <!--main custom templates -->
              <template #[`item.actions`]="{ item }">
                <div class="nowrap">
                  <v-icon dense class="mx-1" @click="openEditFact(formCode, item)">mdi-pencil-outline</v-icon>
                  <v-icon dense class="mx-1" @click="openDeleteFact(formCode, item)">mdi-delete-outline</v-icon>
                </div>
              </template>
              <template #[`item.fak_iga`]="{ item }">
                 <el-checkbox class="mt-0 pt-0" disabled v-model="item.fak_iga" />
              </template>
              <template #[`item.fak_prok`]="{ item }">
                 <el-checkbox class="mt-0 pt-0" disabled v-model="item.fak_prok" />
              </template>
              <template #[`item.fak_kvo`]="{ item }">
                 <el-checkbox class="mt-0 pt-0" disabled v-model="item.fak_kvo" />
              </template>
              <template #[`item.percentage`]="{ item }">
                <span>{{ item.percentage || '-' }} %</span>
              </template>
              <!-- basic templates -->
              <template slot="loading"> {{ $t('Kraunasi...') }} </template>
              <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
              <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {  },
  name: 'signingPersonRuleFactForm',
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      loading: false,
      selectedForms: [],
      expandedForms: [],
    }
  },
  props: {
    jarForms: Array,
    forms: Array,
    facts: Array,
    representationType: String
  },
  mounted() {
    this.expandedForms = this.forms
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
          width: '1rem'
        },
        {
          text: this.$t('Eilės numeris'),
          sortable: false,
          align: 'start',
          value: 'order_no',
        },
        {
          text: this.$t('Faktas'),
          sortable: false,
          align: 'start',
          value: 'jar_fact_title',
        },
        {
          text: this.$t('Įgaliojimo varnelė'),
          sortable: false,
          align: 'start',
          value: 'fak_iga',
        },
        {
          text: this.$t('Prokūros varnelė'),
          sortable: false,
          align: 'start',
          value: 'fak_prok',
        },
        {
          text: this.$t('KVO varnelė'),
          sortable: false,
          align: 'start',
          value: 'fak_kvo',
        },
        {
          text: this.$t('Atstovų dalis'),
          sortable: false,
          align: 'start',
          value: 'percentage',
        },
          {
          text: this.$t('JAR atributas'),
          sortable: false,
          align: 'start',
          value: 'jar_attribute_title',
        },
      ]
    },
    jarFormsForSelect() {
       if (!this.forms || !Array.isArray(this.forms)) {
        return [];
      }

      const filtered = this.jarForms.filter(jarForm => {
        return !this.forms.includes(jarForm.code);
      });

      return filtered.map(jarForm => {
        return {
          code: jarForm.code,
          text: jarForm.text || `Form Code: ${jarForm.code}`,
        };
      });
    }
  },
  methods: {
    addJaForms() {
      if (this.selectedForms.length) {
        this.$emit('add-forms', this.representationType, this.selectedForms)
        this.selectedForms = []
      }
    },
    hideFacts(formCode) {
      this.expandedForms = this.expandedForms.filter(item => item !== formCode)
    },
    showFacts(formCode) {
      this.expandedForms.push(formCode)
    },
    getFormTitle(formCode) {
      const form = this.jarForms.filter(item => item.code === formCode)[0] || {}
      return form.text
    },
    getFormFacts(formCode) {
      return this.facts.filter((item) => {
        return item.jar_form_code == formCode
      })
    },
    openDeleteForm(formCode) {
      this.$emit('init-delete-form', this.representationType, formCode)
    },
    openAddFact(formCode) {
      this.$emit('init-add-fact', this.representationType, formCode)
    },
    openEditFact(formCode, fact) {
      this.$emit('init-edit-fact', this.representationType, formCode, fact)
    },
    openDeleteFact(form, fact) {
      this.$emit('init-delete-fact', this.representationType, form, fact)
    }
  },
}
</script>
